import { EVENTS } from "@archetype-themes/utils/events";

/**
 * Cart page: no AJAX - quantity changes trigger cart/change.js then full page reload.
 * Dynamic logic (progress bar, simulated free gift) lives in section-main-cart.liquid Vue app.
 */
if (document.body.classList.contains("template-cart")) {
  const cartPageForm = document.getElementById("CartPageForm");
  if (cartPageForm) {
    const localesEl = cartPageForm.querySelector("[data-locales]");
    const locales = localesEl ? JSON.parse(localesEl.textContent) : {};

    document.addEventListener("cart:quantity", async (evt) => {
      const [key, qty, el] = evt.detail || [];
      if (!key || qty == null) return;

      if (el) el.classList.add("is-loading");

      try {
        const res = await fetch(`${window.Shopify?.routes?.root || "/"}cart/change.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: key, quantity: qty }),
        });
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.description || "Cart update failed");
        }
        window.location.reload();
      } catch (err) {
        if (el) el.classList.remove("is-loading");
        const input = el?.querySelector?.(".js-qty__num");
        if (input?.dataset?.initialValue) input.value = input.dataset.initialValue;
        alert(err?.message || "Fehler beim Aktualisieren des Warenkorbs.");
      }
    });

    document.addEventListener(EVENTS.ajaxProductAdded, () => {
      window.location.reload();
    });
  }
}
